import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ApplicationState, CommanderThunkDispatch, Option } from '@mews-commander/types';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Select } from '@mews-commander/ui';
import { BillingGrouping } from '../constants';
import { getBillingGrouping } from '../ducks/billing';
import { changeBillingGrouping } from '../actions/billing';

const BillingGroupingSelect = ({ changeGrouping, grouping }: StateProps & DispatchProps) => (
    <Select
        onChange={changeGrouping}
        options={
            [
                {
                    value: BillingGrouping.Reservation,
                    label: <LocalizedText textKey={TextKey.GroupedByReservation} />,
                },
                {
                    value: BillingGrouping.Month,
                    label: <LocalizedText textKey={TextKey.GroupedByMonth} />,
                },
            ] as Array<Option>
        }
        selected={grouping}
    />
);

interface StateProps {
    grouping: BillingGrouping;
}
interface OwnProps {
    scope: string;
}

interface DispatchProps {
    changeGrouping: (grouping: BillingGrouping) => void;
}

export default connect<StateProps, DispatchProps, OwnProps, ApplicationState>(
    createStructuredSelector({
        grouping: getBillingGrouping,
    }),
    (dispatch: CommanderThunkDispatch, { scope }) => ({
        changeGrouping: (grouping) => dispatch(changeBillingGrouping({ grouping, scope })),
    })
)(BillingGroupingSelect);
